<template><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L15 15" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
    <path d="M1 15L15 1" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
</svg>
</template>